import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { ToastProvider } from "./components/ToastContext";
import { SessionProvider } from "./hooks/SessionContext";
import "./styles/app.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Élément racine introuvable.");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
